import React, { PureComponent } from 'react';
import PropType from 'prop-types';
import { translate } from 'react-i18next';
import amplitude from 'amplitude-js/amplitude';
import { PAGE_VISIT_GETSTARTED, CLICK_FORUM_LINK, SURVEY_CLICKED } from '../../constants/amplitudeEvents';
import ExternalLink from '../../components/Link/ExternalLink';

export class GetStartedComponent extends PureComponent {
  static propTypes = {
    t: PropType.func,
  }

  static defaultProps = {
    t: (str) => str,
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    amplitude.getInstance().logEvent(PAGE_VISIT_GETSTARTED, {
      Referrer: document.referrer,
    });
  }

  render() {
    const { t } = this.props;
    return (
      <div>
        <section className="hero is-app-hero is-relative getstarted-hero-image">
          <div className="container is-relative is-suunto app-hero-content is-fullhd">
            <div className="columns">
              <div className="column is-7">
                <h1 className="title is-2 is-size-3-mobile is-size-1-fullhd is-spaced has-text-white is-uppercase">{t('TXT_SUUNTOAPP_WANTS_YOU')}</h1>
                <h2 className="subtitle is-3 is-size-4-mobile is-size-2-fullhd has-text-white">
                  {t('TXT_GETSTARTED_HEADER_DESC1')}
                </h2>
              </div>
              {/* <div className="column is-4 is-offset-1 is-relative is-hidden-touch">
              <img src="/images/frontpage/suunto/iphone_hero_trail_running@2x.png" alt="app example" className="is-absolute-desktop is-app-hero-example-phone" />
            </div> */}
            </div>
          </div>
        </section>
        <div className="container is-relative is-suunto has-medium-gap is-fullhd">
          <div className="columns is-multiline is-vcentered">
            <div className="column is-12-touch is-6-desktop">
              <div className="is-getstarted-box">
                <p className="is-size-4-mobile">
                  {t('TXT_GETSTARTED_CARD1A')}
                </p>
                <br />
                <p className="is-size-4-mobile">
                  {t('TXT_GETSTARTED_CARD1B')}
                </p>
              </div>
            </div>
            <div className="column is-12-touch is-6-desktop is-mobile has-padding-large">
              <figure style={{ height: '184px', width: '184px' }} className="image suunto-app-icon">
                <img src="/images/logo/suuntoapp-icon.png" alt="Suunto App icon" />
              </figure>
            </div>
          </div>
        </div>
        <div className="container is-relative is-suunto has-large-gap is-fullhd">
          <div className="box is-radiusless is-borderless is-paddingless frontpage-box-container">
            <div className="columns is-gapless is-mobile is-multiline">
              <div className="column is-12-touch is-6-desktop fp-box-bg fp-box-bg-1">
                {/* <img src="/images/frontpage/suunto/ui_example_1@2x.png" alt="example 1" className="fp-box-img" /> */}
              </div>
              <div className="column is-12-touch is-6-desktop">
                <div className="is-frontpage-box">
                  <h2 className="title is-2 is-size-3-mobile is-uppercase">{t('TXT_WHAT_DO_I_GET')}</h2>
                  <p>{t('TXT_GETSTARTED_CARD2A')}</p>
                  <p>{t('TXT_GETSTARTED_CARD2B')}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="box is-radiusless is-borderless is-paddingless frontpage-box-container">
            <div className="columns is-gapless is-mobile is-multiline">
              <div className="column is-12-touch is-6-desktop">
                <div className="is-frontpage-box">
                  <h2 className="title is-2 is-size-3-mobile is-uppercase">{t('TXT_WHAT_CAN_I_EXPECT')}</h2>
                  <p>
                    Software updates for the Suunto app will be frequent during beta. Keeping
                    <b>the app</b>
                    {' '}
                    up-to-date will ensure you are getting the best possible experience.
                  </p>
                  <p>{t('TXT_GETSTARTED_CARD3B')}</p>
                </div>
              </div>
              <div className="column is-12-touch is-6-desktop fp-box-bg fp-box-bg-2">
                {/* <img src="/images/frontpage/suunto/ui_example_2@2x.png" alt="example 2" className="fp-box-img" /> */}
              </div>
            </div>
          </div>
          <div className="box is-radiusless is-borderless is-paddingless frontpage-box-container">
            <div className="columns is-gapless is-mobile is-multiline">
              <div className="column is-12-touch is-6-desktop fp-box-bg fp-box-bg-3">
                {/* <img src="/images/frontpage/suunto/ui_example_3@2x.jpg" alt="example 3" className="fp-box-img" /> */}
              </div>
              <div className="column is-12-touch is-6-desktop">
                <div className="is-frontpage-box">
                  <h2 className="title is-2 is-size-3-mobile is-uppercase">{t('TXT_WHERE_CAN_I_GET_HELP')}</h2>
                  <p>
                    During the beta, questions may arise. The Suunto app beta is a unique time when changes are happening rapidly and within a small community. As such, the best place to direct all your beta-related feedback, questions and support needs is to
                    <ExternalLink amplitudeEvent={CLICK_FORUM_LINK} amplitudeSource="GetStartedPage" amplitudeCTA="MoreDetails" text="forum.suunto.com" href="https://forum.suunto.com" />
                    .
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container is-relative is-suunto has-large-gap is-fullhd">
          <h2 className="title is-2 is-size-3-mobile has-text-centered is-uppercase is-home-section-heading is-uppercase">{t('TXT_NEED_TO_KNOWS')}</h2>
          <div className="box is-frontpage-faq is-radiusless is-borderless">
            <div className="columns is-multiline">
              <div className="column is-12">
                <div className="columns is-vcentered">
                  <div className="column is-one-quarter">
                    <figure className="image">
                      <img src="/images/getstarted/get-started-icon-00.svg" alt="Watch and phone" />
                    </figure>
                  </div>
                  <div className="column has-padding-large is-need-to-know-text">
                    <h3>{t('TXT_NEED_TO_KNOW_HEADER0')}</h3>
                    {t('TXT_NEED_TO_KNOW_DESC0A')}
                    <br />
                    <br />
                    {t('TXT_NEED_TO_KNOW_DESC0B')}
                  </div>
                </div>
              </div>
              <div className="column is-12"><div className="divider" /></div>
              <div className="column is-12">
                <div className="columns is-vcentered">
                  <div className="column is-one-quarter">
                    <figure className="image">
                      <img src="/images/getstarted/get-started-icon-01.svg" alt="Watch and phone" />
                    </figure>
                  </div>
                  <div className="column has-padding-large is-need-to-know-text">
                    <h3>{t('TXT_NEED_TO_KNOW_HEADER1')}</h3>
                    {t('TXT_NEED_TO_KNOW_DESC1A')}
                    {' '}
                    {t('TXT_NEED_TO_KNOW_DESC1B')}
                    {' '}
                    <ExternalLink amplitudeEvent={CLICK_FORUM_LINK} amplitudeSource="GetStartedPage" amplitudeCTA="MoreDetails" text="forum.suunto.com" href="https://forum.suunto.com" />
                    .
                  </div>
                </div>
              </div>
              <div className="column is-12"><div className="divider" /></div>
              <div className="column is-12">
                <div className="columns is-vcentered">
                  <div className="column is-one-quarter">
                    <figure className="image">
                      <img src="/images/getstarted/get-started-icon-02.svg" alt="beta" />
                    </figure>
                  </div>
                  <div className="column has-padding-large is-need-to-know-text">
                    <h3>{t('TXT_NEED_TO_KNOW_HEADER2')}</h3>
                    You can join after receiving an email invitation from Suunto. If you haven’t received one and would like to join, you can do so by filling out this
                    {' '}
                    <ExternalLink amplitudeCTA="CallToJoin" amplitudeEvent={SURVEY_CLICKED} amplitudeSource="GetStartedPage" href="https://www.surveygizmo.eu/s3/90052074/Suunto-App-Registration-survey" text="form" />
                    . Depending on when you apply, your invitation may not come immediately, but rest assured it will arrive to your inbox soon thereafter.
                  </div>
                </div>
              </div>
              <div className="column is-12"><div className="divider" /></div>
              <div className="column is-12">
                <div className="columns is-vcentered">
                  <div className="column is-one-quarter">
                    <figure className="image">
                      <img src="/images/getstarted/get-started-icon-03.svg" alt="Remove Suunto Movescount App" />
                    </figure>
                  </div>
                  <div className="column has-padding-large is-need-to-know-text">
                    <h3>{t('TXT_NEED_TO_KNOW_HEADER3')}</h3>
                    {t('TXT_NEED_TO_KNOW_DESC3')}
                    <div className="content">
                      <ul>
                  <li>{t('TXT_NEED_TO_KNOW_DESC3A')}</li>
                  <li>{t('TXT_NEED_TO_KNOW_DESC3B')}</li>
                  <li>{t('TXT_NEED_TO_KNOW_DESC3C')}</li>
                </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="column is-12"><div className="divider" /></div>
              <div className="column is-12">
                <div className="columns is-vcentered">
                  <div className="column is-one-quarter is-need-to-know-text">
                    <figure className="image">
                      <img src="/images/getstarted/get-started-icon-05.svg" alt="Keep your Spartan software up to date" />
                    </figure>
                  </div>
                  <div className="column has-padding-large is-need-to-know-text">
                    <h3>{t('TXT_NEED_TO_KNOW_HEADER5')}</h3>
                    {t('TXT_NEED_TO_KNOW_DESC5')}
                    {' '}
                    (
                    <ExternalLink amplitudeCTA="MoreInfo" amplitudeEvent={CLICK_FORUM_LINK} amplitudeSource="GetStartedPage" href={`https://www.${__REGION__.host}/explorewithsuuntospartan`} text="More info here" />
                    ).
                  </div>
                </div>
              </div>

              <div className="column is-12"><div className="divider" /></div>
              <div className="column is-12">
                <div className="columns is-vcentered">
                  <div className="column is-one-quarter">
                    <figure className="image">
                      <img src="/images/getstarted/get-started-icon-06.svg" alt="Use Suuntolink to still use Suunto Movescount" />
                    </figure>
                  </div>
                  <div className="column has-padding-large is-need-to-know-text">
                    <h3>{t('TXT_NEED_TO_KNOW_HEADER6')}</h3>
                    {t('TXT_NEED_TO_KNOW_DESC6')}
                  </div>
                </div>
              </div>

              <div className="column is-12"><div className="divider" /></div>
              <div className="column is-12">
                <div className="columns is-vcentered">
                  <div className="column is-one-quarter">
                    <figure className="image">
                      <img src="/images/getstarted/get-started-icon-07.svg" alt="Have fun!" />
                    </figure>
                  </div>
                  <div className="column has-padding-large is-need-to-know-text">
                    <h3>{t('TXT_NEED_TO_KNOW_HEADER7')}</h3>
                    {t('TXT_NEED_TO_KNOW_DESC7')}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="has-large-gap is-relative">
          <img className="gettingstartedpage-bottom-hero-image" src="/images/frontpage/suunto/bottom_background@2x.jpg" alt="bottom hero" />
          <h2 className="subtitle is-2 is-size-3-mobile is-gettingstartedpage-bottom-hero-title has-text-white is-absolute is-white has-text-centered">{t('TXT_BE_PART_OF')}</h2>
          <div className="columns gettingstartedpage-bottom-columns">
            <div className="column has-text-centered">
              <ExternalLink amplitudeCTA="CallToJoin" amplitudeEvent={SURVEY_CLICKED} amplitudeSource="GetStartedPage" href="https://www.surveygizmo.eu/s3/90052074/Suunto-App-Registration-survey" className="button is-primary is-medium gettingstartedpage-bottom-button gettingstartedpage-bottom-button-left is-uppercase" text={t('TXT_GET_ACCESS_TO_BETA')} />
            </div>
            <div className="column has-text-centered">
              <ExternalLink amplitudeCTA="CallToJoin" amplitudeEvent={CLICK_FORUM_LINK} amplitudeSource="GetStartedPage" href="https://forum.suunto.com" className="button is-primary is-medium gettingstartedpage-bottom-button gettingstartedpage-bottom-button-right is-uppercase" text={t('TXT_JOIN_THE_DISCUSSION')} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default translate()(GetStartedComponent);
